import { useEffect } from "react";
import { IDynamicTableProps } from "./interface";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./DynamicTable.scss";
import classNames from "classnames";

const DynamicTable = (props: IDynamicTableProps) => {
    const { totalizerFlag, setRowsData, rowsData, tableData, dependantInputs } = props;

    const addTableRows = () => {
        let rowsInput = JSON.parse(JSON.stringify(tableData?.addOnData[0]))
        setRowsData([...rowsData, rowsInput])
    }

    // to check any default data available
    const checkDefaultRowData = (data: any) => {
        const tempArray: any = []
        data?.length > 0 && data?.map((eachRow: any) => {
            tempArray.push(eachRow)
        })
        setRowsData(tempArray)
    }

    useEffect(() => {
        if ((tableData?.defaultData?.length) > 0) {
            checkDefaultRowData(tableData?.defaultData)
        }
        else {
            if (rowsData.length === 0) {
                addTableRows()
            }
        }
    }, [])

    // useEffect(() => {
    //     console.log(rowsData);
    // }, [rowsData?.length])

    const handleChangeTable = (index: number, evnt: any, entireField?: any) => {
        const { name, value } = evnt.target;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = value;
        setRowsData(rowsInput);
    }

    const handleChangeCheckbox = (index: number, evnt: any) => {
        let name = evnt.target.name;
        let value = evnt.target.checked;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = value;
        setRowsData(rowsInput);
    }

    const deleteTableRows = (index: number) => {
        const rows = [...rowsData];
        rows.splice(index, 1);
        setRowsData(rows);
    }

    return (
        <div className="dynamic-table">
            <div className="p-0 m-0">
                <div className="row m-0">
                    <div className="col-12 p-0">
                        {totalizerFlag > 0 &&
                            <table className="table table-bordered">
                                <thead className="thead-light">
                                    <tr className="storage-table-data-header ">
                                        {
                                            tableData?.headerData?.row1?.map((item: any) => {
                                                return (
                                                    <>
                                                        {
                                                            item?.colSpan ?
                                                                <th colSpan={item?.colSpan && item?.colSpan} >
                                                                    <strong>
                                                                        {item?.label}
                                                                    </strong>
                                                                    {item?.required &&
                                                                        <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                                                    }
                                                                    {item?.tooltip && (
                                                                        <div className="ml-2">
                                                                            <div className="pointer" data-toggle="tooltip" data-placement="top" title={item?.tip}>
                                                                                <FontAwesomeIcon icon={faInfoCircle} className="m-0 ps-1 fontCircleInfo" />
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </th>
                                                                :
                                                                <>
                                                                    {item?.key === "add" ?
                                                                        <th className="col-width-action column-align" rowSpan={2} >
                                                                            <button className="btn btn-primary p-2"
                                                                                onClick={addTableRows}
                                                                            >Add+</button>
                                                                        </th>
                                                                        :
                                                                        <th rowSpan={item?.rowSpan && item?.rowSpan} className="col-width column-align" style={{ width: `${item?.width}%` }}>
                                                                            <strong>
                                                                                {item?.label}
                                                                            </strong>
                                                                            {item?.required &&
                                                                                <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                                                            }
                                                                            {item?.tooltip && (
                                                                                <div className="ml-2">
                                                                                    <div className="pointer" data-toggle="tooltip" data-placement="top" title={item?.tip}>
                                                                                        <FontAwesomeIcon icon={faInfoCircle} className="m-0 ps-1 fontCircleInfo" />
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </th>
                                                                    }
                                                                </>
                                                        }
                                                    </>
                                                )
                                            })
                                        }

                                    </tr>
                                    <tr>
                                        {
                                            tableData?.headerData?.row2?.map((item: any) => {
                                                return (
                                                    <th className={classNames("center-middle-col",
                                                        {
                                                            "required": item?.required === true ? true : false
                                                        })} style={{ width: `${item?.width}%` }}>
                                                        <strong>
                                                            {item?.label}
                                                        </strong>
                                                        {item?.required &&
                                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                                        }
                                                        {item?.tooltip && (
                                                            <div className="ml-2">
                                                                <div className="pointer" data-toggle="tooltip" data-placement="top" title={item?.tip}>
                                                                    <FontAwesomeIcon icon={faInfoCircle} className="m-0 ps-1 fontCircleInfo" />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    {rowsData.map((rowData: any, index: number) => {
                                        // const { enable, conversion_factor, channel_number, id, parameter_name, parameter_id, channel_no, minValue, maxValue, coeffA, coeffB } = rowData;
                                        return (
                                            <tr>
                                                {tableData?.bodyData?.map((field: any) => {
                                                    return (
                                                        <>
                                                            <td>
                                                                {field?.type === "checkBox" && field?.key in rowData &&
                                                                    <input type="checkbox"
                                                                        defaultChecked={field?.defaultValue}
                                                                        checked={rowData[field?.key]}
                                                                        onChange={(evnt) => (handleChangeCheckbox(index, evnt))}
                                                                        name={field?.key}
                                                                    />
                                                                }
                                                                {
                                                                    field?.type === "input" && field?.key in rowData && field?.disableDependency &&
                                                                    <input
                                                                        placeholder={field?.placeholder}
                                                                        type={field?.dataType}
                                                                        value={rowData[field?.key]}
                                                                        disabled={rowData[field?.disableDependency] === true ? false : true}
                                                                        onChange={(evnt) => (handleChangeTable(index, evnt))}
                                                                        name={field?.key}
                                                                        className={classNames("form-control form-control-bordered",
                                                                            {
                                                                                "disable-cursor": rowData[field?.disableDependency] === true ? false : true
                                                                            })} />
                                                                }
                                                                {
                                                                    field?.type === "input" && field?.key in rowData && !field?.disableDependency &&
                                                                    <input
                                                                        placeholder={field?.placeholder}
                                                                        type={field?.dataType}
                                                                        value={rowData[field?.key]}
                                                                        onChange={(evnt) => (handleChangeTable(index, evnt))}
                                                                        name={field?.key}
                                                                        className={classNames("form-control form-control-bordered",
                                                                            {
                                                                                "form-missing-bordered": !rowData[field?.key] && field?.required ? (rowData[field?.key] === 0 ? false : true) : false,
                                                                            }
                                                                        )
                                                                        } />
                                                                }
                                                                {
                                                                    field?.type === "select" && field?.key in rowData && field?.disableDependency &&
                                                                    <select
                                                                        className={classNames("form-control form-control-bordered",
                                                                            {
                                                                                "disable-cursor": rowData[field?.disableDependency] === true ? false : true
                                                                            })}
                                                                        placeholder={field?.placeholder}
                                                                        onChange={(evnt) => (handleChangeTable(index, evnt))}
                                                                        disabled={rowData[field?.disableDependency] === true ? false : true}
                                                                        name={field?.key}
                                                                        value={rowData[field?.key] || ""}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {
                                                                            field?.options && field?.options?.map((inneritem: any, innerIndex: number) => {
                                                                                return (
                                                                                    <>
                                                                                        {inneritem?.selected === true ?
                                                                                            <option value={inneritem.value} key={innerIndex} selected>{inneritem.label}</option>
                                                                                            :
                                                                                            <option value={inneritem.value} key={innerIndex}>{inneritem.label}</option>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            }
                                                                            )
                                                                        }
                                                                    </select>
                                                                }
                                                                {
                                                                    field?.type === "select" && field?.key in rowData && !field?.disableDependency &&
                                                                    <select
                                                                        className={classNames("form-control form-control-bordered"
                                                                        )}
                                                                        placeholder={field?.placeholder}
                                                                        onChange={(evnt) => (handleChangeTable(index, evnt))}
                                                                        name={field?.key}
                                                                        value={rowData[field?.key] || ""}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {
                                                                            field?.options && field?.options?.map((inneritem: any, innerIndex: number) => {
                                                                                return (
                                                                                    <>
                                                                                        {inneritem?.selected === true ?
                                                                                            <option value={inneritem.value} key={innerIndex} selected>{inneritem.label}</option>
                                                                                            :
                                                                                            <option value={inneritem.value} key={innerIndex}>{inneritem.label}</option>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            }
                                                                            )
                                                                        }
                                                                    </select>
                                                                }
                                                                {
                                                                    field?.icon &&
                                                                    <FontAwesomeIcon className="pointer" icon={faTrash}
                                                                        onClick={() => (deleteTableRows(index))}
                                                                    />
                                                                }
                                                            </td>

                                                        </>
                                                    )
                                                })}
                                            </tr>
                                        )
                                    }
                                    )
                                    }
                                </tbody >
                            </table>

                        }
                    </div>
                </div>
            </div>
        </div >
    )
}
export default DynamicTable;